import userManager from '@/auth/authService';
import { createFileRoute } from '@tanstack/react-router'
import { useEffect } from 'react';

export const Route = createFileRoute('/silent-renew')({
  component: RouteComponent,
})

function RouteComponent() {
  useEffect(() => {
    userManager.signinSilentCallback().catch(console.error);
  }, []);
  return <p>Renewing session...</p>;
}
